import { render, staticRenderFns } from "./PostAttachments.vue?vue&type=template&id=5ddbbf9f&"
import script from "./PostAttachments.vue?vue&type=script&lang=js&"
export * from "./PostAttachments.vue?vue&type=script&lang=js&"
import style0 from "./PostAttachments.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports